// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"30e99dec","453":"ef1a194b","455":"25fa3841","977":"1c762632"}[chunkId] + ".chunk.js";
};